import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card, CardBody } from 'reactstrap'
import { getSystemSetup } from 'store/Recruitment/actions'
import CreateJobInput from '../CreateJob/CreateJobInput'

const salaryDurations = [
  { name: 'Monthly', value: 'monthly' },
  { name: 'Weekly', value: 'weekly' },
]

const statusOptions = [
  { name: 'Pending', value: 'pending' },
  { name: 'Cancel', value: 'cancel' },
  { name: 'Confirm', value: 'confirm' },
]

function CreateJobOnboardCard({ application, data, onChange }) {
  const dispatch = useDispatch()

  const { currentSystemSetupRows: salaryTypes } = useSelector(
    (store) => store.recruitment
  )

  useEffect(() => {
    dispatch(getSystemSetup(null, 'salary_type'))
  }, [dispatch])

  return (
    <Card className='mt-5'>
      <CardBody>
        <div className='d-flex flex-wrap w-100' style={{ gap: '0rem 1rem' }}>
          <CreateJobInput
            id='jobApplication'
            label='Job Application'
            placeholder='Select Application'
            required={true}
            fullSize={true}
            select={true}
            selectedOptions={[{ name: application.name }]}
          />
          <CreateJobInput
            id='joiningDate'
            label='Joining Date'
            required={true}
            fullSize={false}
            type='date'
            defaultValue={data.joiningDate}
            onChange={(val) => onChange('joiningDate', val)}
          />
          <CreateJobInput
            id='daysOfWeek'
            placeholder='Enter Days Of Week'
            label='Days Of Week'
            fullSize={false}
            type='number'
            defaultValue={data.daysOfWeek}
            onChange={(val) => onChange('daysOfWeek', val)}
          />
          <CreateJobInput
            id='salary'
            placeholder='Enter Salary'
            label='Salary'
            type='number'
            fullSize={false}
            defaultValue={data.salary}
            onChange={(val) => onChange('salary', val)}
          />
          <CreateJobInput
            id='salaryType'
            placeholder='Select Salary Type'
            label='Salary Type'
            fullSize={false}
            select={true}
            required={true}
            options={salaryTypes}
            onChange={(val) => onChange('salaryType', val)}
            selectedOptions={data.salaryType || []}
          />

          <CreateJobInput
            id='salaryDuration'
            placeholder='Select Salary Duration'
            label='Salary Duration'
            fullSize={false}
            select={true}
            options={salaryDurations}
            onChange={(val) => onChange('salaryDuration', val)}
            selectedOptions={data.salaryDuration || []}
          />
          <CreateJobInput
            id='status'
            placeholder='Select Status'
            label='Status'
            fullSize={false}
            select={true}
            options={statusOptions}
            required={true}
            onChange={(val) => onChange('status', val)}
            selectedOptions={data.status || []}
          />
        </div>
      </CardBody>
    </Card>
  )
}

export default CreateJobOnboardCard
